import { Component, inject, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Router, RouterOutlet } from '@angular/router';
import { DatePipe } from '@angular/common';
import { PrimeNG } from 'primeng/config';
import { MessageToastComponent } from '@components/ui-components/message-toast/message-toast.component';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterOutlet,
    MessageToastComponent,
  ],
  providers: [
    DatePipe,
    TranslatePipe,
  ],
})
export class AppComponent implements OnInit {
  private readonly translate = inject(TranslateService);
  private readonly primeng = inject(PrimeNG);
  protected readonly router = inject(Router);

  constructor() {
    this.translate.addLangs(['en', 'ua']);
    this.translate.setDefaultLang('ua');
  }

  ngOnInit() {
    this.primeng.overlayOptions = {
      appendTo: 'body',
    };
  }
}
